import React, { useRef, useContext, useEffect, useState } from "react";
import "./template.scss";
import { QuestionsContextMemorySpace } from "../../../contexts/questions/questionsContext";
import { useLocation, Link } from "react-router-dom";
import dompurify from "dompurify";
import CommonLoader from "../../../components/common/loader";
import axios from "axios";
import EmptyState from "../../../assets/img/hb/EmptyState.svg";
// import MicrositioSidebar from "../../../components/common/micrositio-sidebar";

const TemplateComponent = () => {
  const { question } = useContext(QuestionsContextMemorySpace);
  const [currentData, setCurrentData] = useState(null);
  const refBusqueda = useRef();
  const location = useLocation();
  const [loader, setLoader] = useState(true);
  const [searchTerm, setSearchTerm] = useState(null);
  const sanitizer = dompurify.sanitize;

  useEffect(() => {
    const fetchData = async () => {
      // Obtén el término de búsqueda desde el query string
      const queryParams = new URLSearchParams(location.search);
      const query = queryParams.get("query");

      if (query) {
        // CUANDO ES SEARCH
        setSearchTerm(query);

        try {
          const response = await axios.get(
            `${process.env.REACT_APP_STRAPI_QA}/categorias/search?query=${query}`
          );
          if (response.data.length > 0) {
            setCurrentData(response.data);
          } else {
            setCurrentData(null);
          }
        } catch (error) {
          // console.log("Error", error);
        }
      } else {
        // CUANDO ENTRA DIRECTO A ALGÚN MENÚ
        setSearchTerm(null);
        const rawSlug = location.pathname.split("/").pop() || "";
        let slug = "";
        try {
          slug = decodeURIComponent(rawSlug);
        } catch (_) {
          slug = rawSlug;
        }
        const normalize = (s) =>
          s
            ?.normalize("NFD")
            .replace(/[\u0300-\u036f]/g, "") // quita tildes
            .toLowerCase()
            .replace(/[^a-z0-9]/g, ""); // quita puntuación y espacios

        

        const foundData =
          question.find((item) => item.slug === slug) ||
          question.find((item) => {
            //console.log("QUESTION",normalize(item.slug.trim()),"SLUG",normalize(slug))
            return normalize(item.slug.trim()) === normalize(slug)
      });

        // Si se encuentra, actualiza el estado con los datos correspondientes
        if (foundData) {
          setCurrentData(foundData);
        }
      }

      setLoader(false);
    };

    fetchData();
  }, [location.pathname, location.search, question]);

  const truncateText = (text, maxLength) => {
    if (text.length > maxLength) {
      return text.slice(0, maxLength) + "...";
    }
    return text;
  };

  const verificar = (html) => {
    if (!html || !searchTerm) return html;
    const normalize = (s) =>
      s
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .toLowerCase();
    const termNorm = normalize(searchTerm);

    // Parsear HTML y operar solo sobre nodos de texto (no atributos)
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div id="__root">${html}</div>`, "text/html");
    const root = doc.getElementById("__root");
    if (!root) return html;

    const walker = doc.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    const nodes = [];
    while (walker.nextNode()) {
      const n = walker.currentNode;
      const parentName = n.parentNode && n.parentNode.nodeName;
      if (!n.nodeValue || !n.nodeValue.trim()) continue;
      if (parentName === "SCRIPT" || parentName === "STYLE") continue;
      nodes.push(n);
    }

    nodes.forEach((n) => {
      const original = n.nodeValue;
      const replaced = original
        .split(/(\s+)/)
        .map((part) => {
          if (!part.trim()) return part;
          const norm = normalize(part);
          return norm.includes(termNorm)
            ? `<span style="font-weight:400;background-color: #e6f3ff;color:#003366;padding:0px 3px 0px 3px">${part}</span>`
            : part;
        })
        .join("");

      if (replaced !== original) {
        const holder = doc.createElement("span");
        holder.innerHTML = replaced;
        const frag = doc.createDocumentFragment();
        while (holder.firstChild) frag.appendChild(holder.firstChild);
        n.parentNode.replaceChild(frag, n);
      }
    });

    return root.innerHTML;
  };

  return (
    <section className=" " ref={refBusqueda}>
      {loader ? (
        <CommonLoader />
      ) : searchTerm ? (
        <div className="container container-padre" id="container-resultados">
          {/* TITULO */}
          <div className="row mb-3">
            <div className="col-lg-12">
              <h2 className="section_hb_title title-results search_result_micrositio">
                <b className="section_hb_title">
                  Resultados de búsqueda para "{searchTerm}"
                </b>
              </h2>
            </div>
          </div>

          {/* LISTADO DE PREGUNTAS */}
          <div className="row">
            {Array.isArray(currentData) ? (
              currentData.length === 0 ? (
                <div style={{ textAlign: "center", margin: "auto" }}>
                  <img
                    src={EmptyState}
                    style={{ width: "160px" }}
                    alt="Empty state"
                  />
                  <h4>¡Lo sentimos!</h4>
                  <p className="notFound">
                    No encontramos resultados para tu búsqueda.
                  </p>
                </div>
              ) : (
                currentData.map((data) =>
                  data?.subCategorias?.map((categoria) => (
                    <div
                      key={categoria.id}
                      className="col-12 mb-4 preguntas-contenido"
                    >
                      <div className="breadcrumb-container">
                        <nav aria-label="breadcrumb">
                          <ol className="breadcrumb">
                            <li className="breadcrumb-item">
                              <Link to={`/micrositio`}>Central de Ayuda</Link>
                            </li>
                            <li
                              className="breadcrumb-item active-breadcrumb"
                              aria-current="page"
                            >
                              <span dangerouslySetInnerHTML={{ __html: verificar(data?.titulo) }} />
                              
                            </li>
                          </ol>
                        </nav>
                      </div>
                      <h4><span dangerouslySetInnerHTML={{ __html: verificar(categoria?.titulo) }} /></h4>
                      <div>
                        <p className="contenido">
                          <div
                            dangerouslySetInnerHTML={{
                              __html: sanitizer(
                                categoria?.contenido.length > 583
                                  ? truncateText(verificar(categoria?.contenido), 583)
                                  : verificar(categoria?.contenido)
                              ),
                            }}
                          />
                          {/* Mostrar "Ver más" solo si el texto fue truncado */}
                          {categoria?.contenido.length > 483 && (
                            <Link
                              to={`/micrositio/${data?.slug}/${categoria?.id}`}
                              className="ver-mas"
                            >
                              Ver más
                            </Link>
                          )}
                        </p>
                      </div>
                    </div>
                  ))
                )
              )
            ) : currentData && currentData.subCategorias ? (
              currentData.subCategorias.map((categoria) => (
                <div
                  key={categoria.id}
                  className="col-12 mb-4 preguntas-contenido"
                >
                  <div className="breadcrumb-container">
                    <nav aria-label="breadcrumb">
                      <ol className="breadcrumb">
                        <li className="breadcrumb-item">
                          <Link to={`/micrositio`}>Central de Ayuda</Link>
                        </li>
                        <li
                          className="breadcrumb-item active-breadcrumb"
                          aria-current="page"
                        >
                          {currentData?.titulo}
                        </li>
                      </ol>
                    </nav>
                  </div>
                  <h4>{categoria?.titulo}</h4>
                  <div>
                    <p className="contenido">
                      <div
                        dangerouslySetInnerHTML={{
                          __html: sanitizer(
                            categoria?.contenido.length > 483
                              ? truncateText(categoria?.contenido, 483)
                              : categoria?.contenido
                          ),
                        }}
                      />
                      {/* Mostrar "Ver más" solo si el texto fue truncado */}
                      {categoria?.contenido.length > 483 && (
                        <Link
                          to={`/${currentData?.slug}/${categoria?.id}`}
                          className="ver-mas"
                        >
                          Ver más
                        </Link>
                      )}
                    </p>
                  </div>
                </div>
              ))
            ) : (
              <div style={{ textAlign: "center", margin: "auto" }}>
                <img
                  src={EmptyState}
                  style={{ width: "160px" }}
                  alt="Empty state"
                />
                <h4>¡Lo sentimos!</h4>
                <p className="notFound">
                  No encontramos resultados para tu búsqueda.
                </p>
              </div>
            )}
          </div>
        </div>
      ) : (
        <div className="container container-padre" id="container-resultados">
          {/* TITULO */}
          <div className="row mb-3">
            <div className="col-lg-12">
              <h2 className="section_hb_title title-results">
                <b className="section_hb_title">{currentData?.titulo}</b>
              </h2>
            </div>
          </div>

          {/* LISTADO DE PREGUNTAS */}
          <div className="row">
            {currentData?.subCategorias.map((categoria) => (
              <div
                key={categoria.id}
                className="col-12 mb-4 preguntas-contenido"
              >
                <div className="breadcrumb-container">
                  <nav aria-label="breadcrumb">
                    <ol className="breadcrumb">
                      <li className="breadcrumb-item">
                        <Link to={`/micrositio`}>Central de Ayuda</Link>
                      </li>
                      <li
                        className="breadcrumb-item active-breadcrumb"
                        aria-current="page"
                      >
                        {currentData?.titulo}
                      </li>
                    </ol>
                  </nav>
                </div>
                <h4>{categoria?.titulo}</h4>
                <div>
                  <p className="contenido">
                    <div
                      dangerouslySetInnerHTML={{
                        __html: sanitizer(
                          categoria?.contenido.length > 483
                            ? truncateText(categoria?.contenido, 483)
                            : categoria?.contenido
                        ),
                      }}
                    />
                    {/* Mostrar "Ver más" solo si el texto fue truncado */}
                    {categoria?.contenido.length > 483 && (
                      <Link
                        to={`${categoria?.id}`}
                        className="ver-mas"
                      >
                        Ver más
                      </Link>
                    )}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </section>
  );
};

export default TemplateComponent;
